import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/information',
    name: 'information',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import( /* webpackChunkName: "about" */ './views/Information.vue')
    }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import('./views/Clients.vue')
  },
  {
    path: '/project/:project',
    name: 'Project',
    component: () => import('./views/Project.vue'),
  },
  {
    path: '/packaging',
    name: 'Packaging',
    component: () => import('./views/Packaging.vue')
  },
  {
    path: '/photography',
    name: 'Photography',
    component: () => import('./views/Photography.vue')
  },
  {
    path: '/branding',
    name: 'Branding',
    component: () => import('./views/Branding.vue')
  },
  {
    path: '/categoria4/',
    name: 'categoria4',
    component: () => import('./views/Categoria4.vue')
  },
  {
    path: '/categoria5',
    name: 'categoria5',
    component: () => import('./views/Categoria5.vue')
  },
  {
    path: '/categoria6',
    name: 'categoria6',
    component: () => import('./views/Categoria6.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('./views/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('./views/Privacy.vue')
  },
  // {
  //   path: '/work',
  //   name: 'Work',
  //   component: () => import('./views/Work.vue')
  // },
  {
    path: '/contact',
    name: 'Contacto',
    component: () => import('./views/Contact.vue')
  },
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }
    var myDiv = document.getElementById('right-column');
    myDiv.scrollTop = 0;
    return goTo(scrollTo)
  },
})

export default router